// Paleta de las gráficas. Vive aparte de los componentes a propósito: son
// datos, no piezas de interfaz.
//
// VALIDADA, no elegida a ojo (validate_palette.js, superficie blanca,
// modo claro):
//   · SERIE (entradas #0067c0 / salidas #eb6834) → paleta categórica de
//     dos ranuras. ΔE 24.7 con protanopia y 35.7 en visión normal; pasa
//     las cinco comprobaciones (banda de luminosidad, croma, separación
//     bajo daltonismo, piso de visión normal y contraste).
//   · RAMPA_ABC → rampa ORDINAL de un solo tono. Las clases ABC son una
//     escala ordenada (A es lo que más vale), no identidades sueltas, así
//     que les toca un tono con luminosidad monótona y no colores
//     distintos. El paso más claro queda a 2.11:1 del blanco, por encima
//     del 2:1 exigido.
//
// AHORA HAY VARIANTE OSCURA (O-7), y no se obtuvo invirtiendo la clara:
// sobre negro el azul y el naranja pierden separacion, asi que la serie
// se REELIGIO contra la superficie oscura y se volvio a comprobar. Los
// valores de los dos temas viven en `index.css`, y aqui solo quedan sus
// nombres.
//
// SE EXPORTAN REFERENCIAS CSS, NO HEXADECIMALES. Un SVG acepta
// `fill="var(--grafica-entradas)"`, asi que la grafica cambia de tema
// sola: sin escuchar nada, sin volver a pintarse y sin que ningun
// componente tenga que enterarse de que existe un tema.
export const SERIE = {
  entradas: 'var(--grafica-entradas)',
  salidas: 'var(--grafica-salidas)',
};
export const RAMPA_ABC = {
  A: 'var(--grafica-abc-a)',
  B: 'var(--grafica-abc-b)',
  C: 'var(--grafica-abc-c)',
  SIN: 'var(--grafica-abc-sin)',
};

// Cromo de la gráfica: rejilla y ejes recesivos, un tono por encima de la
// superficie. Siempre línea sólida — una rejilla punteada se lee como
// "proyección" o "umbral" cuando solo es una rejilla.
export const TINTA_EJE = 'var(--grafica-tinta)';
export const REJILLA = 'var(--grafica-rejilla)';

// Los valores de verdad, para poder COMPROBARLOS. `pruebas/paleta.test.js`
// mide contraste y separacion sobre cada superficie; sin esta tabla la
// validacion tendria que leer el CSS compilado, y una paleta que solo se
// puede validar a ojo se degrada en la primera prisa.
export const VALORES = {
  claro: {
    superficie: '#ffffff',
    lienzo: '#f3f3f3',
    entradas: '#0067c0', salidas: '#eb6834',
    abc: ['#104281', '#2a78d6', '#86b6ef'],
    tinta: '#898781', rejilla: '#e1e0d9',
    texto: '#111827', textoSecundario: '#6a7282',
    marca: '#0067c0',
  },
  oscuro: {
    superficie: '#191b20',
    lienzo: '#101216',
    entradas: '#5aa9f5', salidas: '#ff9152',
    abc: ['#9ccbf8', '#4d93dd', '#2b5f9c'],
    tinta: '#9a9790', rejilla: '#33363c',
    texto: '#f0f3f7', textoSecundario: '#a6adb9',
    marca: '#4da3f0',
  },
};
